import React from "react"
import autobind from "class-autobind"
import Draggable from "react-draggable"
import * as api from "../../api"
import { IFreeAccountMetricsData } from "../../models"
import { Paper, RaisedButton } from "material-ui"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
import FreeAccountDataUsageLinearProgress from "./FreeAccountDataUsageLinearProgress"

interface IProps {
    accountId: string
    accountDrawerOpen?: boolean
    showInSubscriptionDrawer?: boolean
}
interface IState {
    data: IFreeAccountMetricsData
}

export default class FreeAccountDataUsageBanner extends React.Component<IProps, IState> {
    private timer
    constructor(props: IProps) {
        super(props)
        this.state = {
            data: null
        }
        autobind(this)
    }

    componentDidMount() {
        this.getFreeAccountMetricsData()
        this.timer = setInterval(() => this.getFreeAccountMetricsData(), 60000)
        AppStateStore.on("trigger_getFreeAccountMetricsData", this.getFreeAccountMetricsData)
    }

    componentWillUnmount() {
        this.timer &&
            clearInterval(this.timer)
        AppStateStore.removeListener("trigger_getFreeAccountMetricsData", this.getFreeAccountMetricsData)
    }

    getFreeAccountMetricsData() {
        api.getFreeAccountMetricsData(this.props.accountId).then(res =>
            this.setState({ data: res.data })
        )
    }

    render() {
        return !this.state.data ?
            null :
            this.props.showInSubscriptionDrawer ?
                <FreeAccountDataUsageLinearProgress
                    showInSubscriptionDrawer
                    data={this.state.data}
                /> :
                (this.props.accountDrawerOpen || (this.state.data.PunchCount < 1000 && this.state.data.JobCount < 10 && this.state.data.EmployeeCount < 100 && this.state.data.ClientCount < 10)) ?
                    null :
                    <Draggable
                        defaultPosition={{ x: -window.innerWidth + 150, y: window.innerHeight - 275 }}
                    >
                        <Paper style={{ height: 250, minWidth: 225, zIndex: 2500, transition: null, padding: 15 }} zDepth={2} rounded={false}>
                            <div style={{ fontSize: 16, fontWeight: 500 }}>{strings.Data}</div>
                            <FreeAccountDataUsageLinearProgress
                                data={this.state.data}
                            />
                            <RaisedButton
                                data-intercom-target={"FreeAccountDataUsageBanner-Upgrade-Btn"}
                                label={strings.Upgrade}
                                secondary
                                style={{ marginTop: 15, marginLeft: 100 }}
                                onTouchTap={() => AppStateStore.openAccountBillingDrawer()}
                            />
                        </Paper>
                    </Draggable>
    }
}

